<template>
  <template v-if="!showRefresh">
    <div v-if="!isOutLine && !isNotPreview">
      <router-view v-if="!loading"> </router-view>
      <Loading
        class="center"
        v-else
        type="spinner"
        :color="loadingColor"
        vertical
        >加载中...</Loading
      >
    </div>
    <template v-else>
      <div v-if="isOutLine" class="out-line"></div>
      <div v-if="isNotPreview" class="not-preview">
        问卷已发布，请使用正式地址
      </div>
    </template>
  </template>
  <template v-else>
    <p class="tips">活动异常火爆，请点击"刷新"重新进入</p>
    <Button @click="handleRefreshClick" class="submit-btn" type="primary"
      >刷新</Button
    >
  </template>
</template>
<script setup>
import { onMounted, ref, watchEffect, watch } from 'vue'
import { useStore } from 'vuex'
import { Loading, Button, Dialog } from 'vant'
import { getQuesInfo, getShareConfig } from '@/api/index'
import { getWhiteList, getRankConfig } from '@/api/rank'
import { getQueryString } from '@/utils/tools'
import { WebBridgeApi } from 'ijsbridge'
import { useComminDiyStyleEffect } from '@/effects/styleConfigEffect'
import {
  useBlockShare,
  setWechatShareConfig,
  useInitBurying,
  useQuesPageview,
} from '@/hooks'
import { useRoute, useRouter } from 'vue-router'
import VConsole from 'vconsole'
import { GXXMS_QUES_KEY } from '@/constants/index'

// 获取试卷信息
const loading = ref(true)
const isOutLine = ref(false)
const isNotPreview = ref(false)
const route = useRoute()
const router = useRouter()
const store = useStore()
const questionActiveKey = getQueryString('questionActiveKey')
const isPreview = Number(getQueryString('isPreview'))

const { setApiSyleConfig } = useComminDiyStyleEffect()

const showRefresh = ref(false)
// TEMP
const type = getQueryString('type')

const handleRefreshClick = () => {
  location.reload()
}

const envVersion = process.env.VUE_APP_ENV_VERSION === 'prod' ? 'release' : 'trial'

// 获取试卷信息
const getQues = () => {
  store.commit('setType', {
    data: type,
  })
  const getInfo = async () => {
    try {
      const result = await getQuesInfo({
        questionActiveKey,
        isPreview,
        token: store.getters.getToken,
      })
      if (result?.ok) {
        useQuesPageview({
          quesTitle: result?.dataMap?.title,
          quesType: result?.dataMap?.type,
        })
        // 已发布 不能预览了
        if (result?.ret === '-1') {
          Dialog({ message: result?.comment })
          loading.value = false
          isNotPreview.value = true
          return
        }
        if (result?.dataMap?.status === 5 || result?.dataMap?.status === 6) {
          const message =
            result?.dataMap?.status === 5 ? '活动未开始' : '活动已结束'
          if (result?.dataMap.type !== 11) {
            Dialog({ message: message })
          }
        }
        // 屏蔽设置分享
        if (result?.dataMap?.shareStatus === 2) {
          useBlockShare()
        }

        // 问卷的时候获取一下admin权限
        if (result?.dataMap.type === 1 && store.getters.getToken) {
          store.dispatch('fetchHasAdminAuth')
        }

        store.commit('initQuesInfo', {
          data: {
            ...result.dataMap,
          },
        })
        store.commit('initQuseSetting', {
          data: {
            ...result.dataMap.setting,
            // answerStatus: 1
          },
        })
        const orgId = getQueryString('orgid')
        if (orgId === '409') {
          document.title = ''
        } else {
          document.title = result.dataMap.title
        }

        setApiSyleConfig(
          result.dataMap,
          result.dataMap?.setting,
          result.dataMap?.style
        )
      } else {
        Dialog({ message: result.comment })
      }
      loading.value = false
    } catch (e) {
      console.log('error', e)
      showRefresh.value = true
      loading.value = false
    }
  }
  getInfo()
}

// 获取设置分享信息
const setAppShareConfig = () => {
  const store = useStore()
  window.shareWexnDescription = store.getters.getQuesInfo?.content
  window.shareWexnTitle = store.getters.getQuesInfo?.title
  // window.shareWexnIcon = ''
  const getConfig = async () => {
    try {
      const res = await getShareConfig({
        questionActiveKey: getQueryString('questionActiveKey'),
      })
      if (res.ok) {
        store.commit('setShareInfo', {
          data: res.data,
        })

        WebBridgeApi.requestApi('extandsShareData', {
          url: window.location.href,
          title: res.data?.shareTitle || document.title,
          desc: res.data?.shareDesc,
          image: res.data?.shareIcon || null,
        }).then(({ result, err }) => {
          console.log('result', result)
          console.log('err', err)
        })

        // 获取微信分享信息
        if (res.data) {
          setWechatShareConfig({
            title: res.data?.shareTitle || document.title,
            desc: res.data.shareDesc,
            shareIcon: res.data.shareIcon,
            url: window.location.href,
          })
        }
      }
    } catch (e) {
      setWechatShareConfig({
        title: document.title,
        desc: store.getters.getQuesInfo?.content,
        shareIcon:
          'https://img11.iqilu.com/29/2021/04/08/c4f73a500edb3c1acefbce4c0e7cd12f.jpg',
        url: window.location.href,
      })
    }
  }

  getConfig()
}

// 获取排行配置
const fetchRankConfig = async () => {
  const questionActiveKey = getQueryString('questionActiveKey')
  const route = useRoute()
  const store = useStore()
  // 育新人屏蔽掉
  if (questionActiveKey === GXXMS_QUES_KEY) {
    return
  }
  const res = await getRankConfig({
    questionActiveKey,
  })

  if (res.ok && res.data) {
    store.commit('setRankConfig', {
      data: res.data,
    })
  }
}

// 开发环境开启vconsole
if (process.env.NODE_ENV !== 'production') {
  const vConsole = new VConsole()
}

const orgId = getQueryString('orgid')
if (orgId === '409') {
  document.title = ''
}

// 这套卷子临时处理loading颜色
const loadingColor = ref('#2faeff')
if (
  getQueryString('questionActiveKey') ===
  '3b42e4f940314db3b110673cf87117ae'
) {
  loadingColor.value = '#ffffff'
}

// 处理作为嵌入的iframe情况下登陆
function handleAsIframeLogin(params) {
  const isFromIframe = getQueryString('isFromIframe')

  if (!isFromIframe) {
    return
  }

  window.addEventListener('message', function(event) {
    const token = event.data.token
    if (isFromIframe && token) {
      store.commit('setToken', {
        token: token,
      })
      store.commit('setUser', {
        user: {
          avatar: event?.data?.avatar,
          nickname: event?.data?.nickname,
          id: event?.data?.id,
        },
      })
    }
  }, false)
}

// 检测url里是否有urlToken，有的话设置token
function handleCheckUrlToken() {
  const urlToken = getQueryString('urlToken')
  const urlUserInfo = getQueryString('urlUserInfo')
  if (urlToken) {
    store.commit('setToken', {
      token: urlToken,
    })
  }

  if (urlUserInfo) {
    store.commit('setUser', {
      user: JSON.parse(decodeURIComponent(urlUserInfo))
    })
  }
}

onMounted(() => {
  WebBridgeApi.requestApi('hideLoading', {});
  handleCheckUrlToken()
  getQues()
  // 设置app分享信息
  setAppShareConfig()
  fetchRankConfig()
  useInitBurying(orgId, store.getters.getUser?.id)

  handleAsIframeLogin()
})
</script>
<style lang="scss" scoped>
#app {
  margin: 0 auto;
}
.center {
  margin: 400px auto;
  text-align: center;
}

.out-line {
  width: 100%;
  height: 100vh;
  background: no-repeat center/80% url('./assets/img/offline-bg.png');
}

.not-preview {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  background-color: #ffffff;

  z-index: 2077;
}

.tips {
  margin-top: 400px;
  text-align: center;
  color: #333;
  font-size: 36px;
}

.submit-btn {
  margin: 136px auto;
  display: block;
  width: 400px;
  height: 88px;
  background: linear-gradient(-90deg, #388fff 0%, #2faeff 100%);
  border-radius: 44px;
  border: 1px solid #2faeff;
  font-size: 34px;
  font-weight: 500;
  color: #ffffff;
}
</style>
